import { z } from 'zod';
export const percentOptionsSchema = z.object({});
export const percentCellSchema = z.number();
//# sourceMappingURL=percent.js.map